module.exports = __webpack_public_path__ + "img/audioring@2x.7399ff1.webp";